<template>
  <ValidationProvider
    tag="div"
    :skipIfEmpty="false"
    :rules="rulesObject"
    v-slot="{ errors }"
  >
    <BaseCheckbox
      v-model="value"
      @input="purposeChanged"
      :id="$id(purpose.id + '-purpose')"
      :name="$id(purpose.id + '-purpose')"
    >
      <span ref="text" v-html="purposeTextWithStar"></span>
    </BaseCheckbox>

    <div class="f-text-red-600 f-text-xs f-mt-1" v-if="getFirstError(errors)">
      {{ getFirstError(errors) }}
    </div>
  </ValidationProvider>
</template>

<script lang="ts">
import Vue from "vue";
import BaseCheckbox from "@/components/Form/Basic/Inputs/BaseCheckbox.vue";
import { ValidationProvider } from "vee-validate";
import CheckboxValidationMixin from "@/components/Form/Basic/Inputs/CheckboxValidationMixin";

export default Vue.extend({
  name: "Purpose",

  components: { BaseCheckbox, ValidationProvider },

  props: {
    purpose: {
      type: Object,
      required: true,
    },
  },

  computed: {
    required(): boolean {
      return this.purpose.required;
    },

    rulesObject(): object {
      return { required: { allowFalse: !this.required } };
    },

    purposeTextWithStar(): string {
      const star = this.required ? " *" : "";
      return this.purpose.html + star;
    },
  },

  methods: {
    purposeChanged(value: boolean): void {
      const textElement = this.$refs.text as HTMLElement;

      this.$emit("purposeChanged", {
        form_purpose_id: this.purpose.id,
        text: textElement.innerHTML,
        checked: value,
      });
    },
  },

  mounted(): void {
    const element = this.$refs.text as HTMLElement;

    element.querySelectorAll("a").forEach((item) => {
      item.classList.add("f-text-blue-500");
      item.classList.add("hover:f-underline");
    });

    this.purposeChanged(false);
  },

  mixins: [CheckboxValidationMixin],
});
</script>

<style></style>
